import { User } from 'types';

/** Maps a /users/me response into the User shape expected by layout and document flows. */
export const mapMeResponseToUser = (me: Record<string, any>): User => {
	const firstName = me.firstName ?? me.first_name ?? '';
	const lastName = me.lastName ?? me.last_name ?? '';

	return {
		id: me.id,
		name: `${firstName} ${lastName}`.trim(),
		firstName,
		lastName,
		hierarchy: me.hierarchy ?? null,
		startDate: me.startDate,
		securityRole: me.securityRole,
		phone: me.phone ?? '',
		email: me.email ?? '',
		middleName: me.middleName ?? me.middle_name,
		maritalStatus: me.maritalStatus ?? '',
		gender: me.gender ?? '',
		addressLine1: me.addressLine1 ?? '',
		addressLine2: me.addressLine2,
		city: me.city ?? '',
		state: me.state ?? '',
		country: me.country ?? '',
		postcode: me.postcode ?? '',
		separation: me.separation ?? false,
		separationDate: me.separationDate,
		userMustChangePasswordOnNextLogin: me.userMustChangePasswordOnNextLogin,
		sharedEmployeeWorkplace: me.sharedEmployeeWorkplace,
		isOnboardingInProgress: me.isOnboardingInProgress,
		userNotes: me.userNotes,
		userType: me.userType,
	};
};

/**
 * Resolves the logged-in user for app shell/layout.
 * Prefers the enriched workplace user list when present; falls back to /users/me
 * when the current user is excluded from picker lists (e.g. admin@byod.ai).
 */
export const resolveLoggedInWorkplaceUser = (
	userInfo: Record<string, any> | undefined | null,
	usersData: Record<string, any>[] | undefined
): User | undefined => {
	if (!userInfo?.id) {
		return undefined;
	}

	const fromWorkplaceList = usersData?.find((user) => user.id === userInfo.id);
	if (fromWorkplaceList) {
		return fromWorkplaceList as User;
	}

	// Workplace list finished loading but user is absent (filtered system account).
	if (usersData !== undefined) {
		return mapMeResponseToUser(userInfo);
	}

	return undefined;
};
